export default interface CopilotPrioritizeCustomPrompt {
    prompt: string;
    modelName: string;
}

export const defaultCustomPrompt: CopilotPrioritizeCustomPrompt = {
    prompt: '',
    modelName: '',
};
